import React from 'react';
export function BadgeSystem() {
  return <section className="py-12 sm:py-20" data-id="element-14">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-15">
        <div className="rounded-2xl border border-gold-dim bg-[linear-gradient(135deg,#1a1400,var(--card))] px-6 py-12 text-center sm:px-10" data-id="element-16">
          <div className="font-serif text-[48px] font-black leading-none text-gold sm:text-[64px]" data-id="element-17">
            N°1
          </div>
          <div className="mb-8 mt-2 text-[14px] uppercase tracking-[0.12em] text-muted" data-id="element-18">
            Sistema de joyería y oro · Argentina · 2025
          </div>
          <div className="text-text" data-id="element-19">
            Sistema completo · 8 Tomos + 3 Bonos · Desde cero hasta negocio con
            marca propia · Todo resuelto.
          </div>

          <div className="my-8 flex flex-wrap justify-center gap-8 sm:gap-12" data-id="element-20">
            <div className="text-center" data-id="element-21">
              <div className="font-serif text-[28px] font-bold text-gold" data-id="element-22">
                +300 pág.
              </div>
              <div className="text-[11px] tracking-[0.08em] text-muted" data-id="element-23">
                Contenido real
              </div>
            </div>
            <div className="text-center" data-id="element-24">
              <div className="font-serif text-[28px] font-bold text-gold" data-id="element-25">
                +50
              </div>
              <div className="text-[11px] tracking-[0.08em] text-muted" data-id="element-26">
                Proveedores verificados
              </div>
            </div>
            <div className="text-center" data-id="element-27">
              <div className="font-serif text-[28px] font-bold text-gold" data-id="element-28">
                39
              </div>
              <div className="text-[11px] tracking-[0.08em] text-muted" data-id="element-29">
                Ferias y mercados
              </div>
            </div>
            <div className="text-center" data-id="element-30">
              <div className="font-serif text-[28px] font-bold text-gold" data-id="element-31">
                30 días
              </div>
              <div className="text-[11px] tracking-[0.08em] text-muted" data-id="element-32">
                Primera venta garantizada
              </div>
            </div>
          </div>

          <div className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-33">
            {['Proveedores AR', 'Tipos de oro', 'Fórmula de precios', 'Guiones de venta', 'Control de stock', 'Ferias y mercados', 'Redes sociales', 'Fidelización', 'Negociación en el Once', 'Planillas listas'].map(tag => <span key={tag} className="rounded-full border border-gold/20 bg-gold/10 px-3.5 py-1.5 text-[11px] tracking-[0.06em] text-gold" data-id="element-34">
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}